import { createPopupStore } from './createPopupStore';

export type LoginPopupPayload = {
  retry?: () => void;
};

export const useLoginPopup = createPopupStore<LoginPopupPayload>();
